import api from "../../core/api";
import { Customer } from "../models/customersModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
}

class PublicCustomersApi {
  getCustomer(id: string): Promise<Customer> {
    return api.get<Customer>(`/v1/public/customers/${id}`, getRequestConfig()).then(x => x.data);
  }
}

export default new PublicCustomersApi();